import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "./data";

export default function Faq() {
  const [active, setActive] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="常见问题 · FAQ"
          title="关于官方入口，你可能想问"
          desc="以下为高频问题与统一解答。若仍无法解决，可在认证角标下方找到官方联系入口，我们会尽快回复。"
          align="center"
        />

        <div className="mt-8 space-y-3 md:mt-10">
          {faqs.map((item, index) => {
            const isOpen = active === index;
            return (
              <div
                key={item.q}
                className={"overflow-hidden rounded-lg border bg-background-50 transition-colors " + (isOpen ? "border-primary-300" : "border-background-200")}
              >
                <button
                  type="button"
                  onClick={() => setActive(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                >
                  <span className="flex items-start gap-3">
                    <span className={"mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold " + (isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700")}>
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="text-sm font-semibold text-foreground-950 md:text-base">{item.q}</span>
                  </span>
                  <i
                    className={
                      "mt-0.5 shrink-0 text-lg text-foreground-500 transition-transform duration-300 " +
                      (isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line")
                    }
                  ></i>
                </button>
                <div className={isOpen ? "block" : "hidden"}>
                  <p className="border-t border-background-100 px-4 py-4 pl-14 text-sm leading-relaxed text-foreground-600 md:px-5 md:text-[15px]">
                    {item.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}